import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFieldDropdown, NumericInputField} from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';

function ProductOrderingEditTemplate({ productOrderingEditViewStore }) {
    const {
        contentLoading,
        form,
        subCategoryStore,
        productStore
    } = productOrderingEditViewStore;

    return (
        <ApplicationEditLayout store={productOrderingEditViewStore}>
            <Content loading={contentLoading} >
                <div className="row">
                    <div className="col col-sml-8 col-lrg-7">
                        <div className="card card--form card--primary card--med">
                            <div className="row">
                                <div className="form__group col col-lrg-5 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('productId')} store={productStore}/>
                                </div>

                                <div className="form__group col col-lrg-5 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('subCategoryId')} store={subCategoryStore}/>
                                </div>

                                <div className="form__group col col-lrg-2 u-mar--bottom--sml">
                                    <NumericInputField field={form.$('sort')} />
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    )
}

ProductOrderingEditTemplate.propTypes = {
    productOrderingEditViewStore: PropTypes.object,
};

export default defaultTemplate(ProductOrderingEditTemplate);
